module.exports = {
  "/": {
    "name": "home",
    "success": {
      "all sections loaded": [
        "HOMEPAGE_ANNOUNCEMENTS_LOADED",
        "HOMEPAGE_IN_PROGRESS_LOADED",
        "HOMEPAGE_PERSONA_RECOMMENDATIONS_LOADED",
        "HOMEPAGE_RECOMMENDATIONS_LOADED",
        "HOMEPAGE_POPULAR_CERTIFICATES_LOADED"
      ],
      "critical sections with in progress": [
        "HOMEPAGE_IN_PROGRESS_LOADED",
        "HOMEPAGE_PERSONA_RECOMMENDATIONS_LOADED",
        "HOMEPAGE_RECOMMENDATIONS_LOADED",
        "HOMEPAGE_POPULAR_CERTIFICATES_LOADED"
      ],
      "critical sections with announcements": [
        "HOMEPAGE_ANNOUNCEMENTS_LOADED",
        "HOMEPAGE_PERSONA_RECOMMENDATIONS_LOADED",
        "HOMEPAGE_RECOMMENDATIONS_LOADED",
        "HOMEPAGE_POPULAR_CERTIFICATES_LOADED"
      ],
      "critical sections only": [
        "HOMEPAGE_PERSONA_RECOMMENDATIONS_LOADED",
        "HOMEPAGE_RECOMMENDATIONS_LOADED",
        "HOMEPAGE_POPULAR_CERTIFICATES_LOADED"
      ],
      "api not found": [
        "HOMEPAGE_API_404"
      ]
    },
    "partialSuccess": {
      "persona recommendations error": [
        "HOMEPAGE_PERSONA_RECOMMENDATIONS_ERROR",
        "HOMEPAGE_RECOMMENDATIONS_LOADED",
        "HOMEPAGE_POPULAR_CERTIFICATES_LOADED"
      ],
      "recommendations error": [
        "HOMEPAGE_PERSONA_RECOMMENDATIONS_LOADED",
        "HOMEPAGE_RECOMMENDATIONS_ERROR",
        "HOMEPAGE_POPULAR_CERTIFICATES_LOADED"
      ],
      "certificates error": [
        "HOMEPAGE_PERSONA_RECOMMENDATIONS_LOADED",
        "HOMEPAGE_RECOMMENDATIONS_LOADED",
        "HOMEPAGE_POPULAR_CERTIFICATES_ERROR"
      ],
      "persona and recommendations error": [
        "HOMEPAGE_PERSONA_RECOMMENDATIONS_ERROR",
        "HOMEPAGE_RECOMMENDATIONS_ERROR",
        "HOMEPAGE_POPULAR_CERTIFICATES_LOADED"
      ],
      "persona and certificates error": [
        "HOMEPAGE_PERSONA_RECOMMENDATIONS_ERROR",
        "HOMEPAGE_RECOMMENDATIONS_LOADED",
        "HOMEPAGE_POPULAR_CERTIFICATES_ERROR"
      ],
      "recommendations and certificates error": [
        "HOMEPAGE_PERSONA_RECOMMENDATIONS_LOADED",
        "HOMEPAGE_RECOMMENDATIONS_ERROR",
        "HOMEPAGE_POPULAR_CERTIFICATES_ERROR"
      ]
    },
    "error": [
      "HOMEPAGE_API_ERROR"
    ]
  },
  "/welcome": {
    "name": "welcome",
    "success": {
      "default": [
        "WELCOME_VIEW_LOADED"
      ]
    }
  },
  "/wizard": {
    "name": "wizard",
    "success": {
      "default": [
        "WIZARD_VIEW_LOADED"
      ]
    }
  },
  "/wizard/*": {
    "name": "wizard-subpage",
    "success": {
      "default": [
        "WIZARD_VIEW_LOADED"
      ]
    }
  },
  "/results": {
    "name": "catalog",
    "success": {
      "catalog courses loaded": [
        "CATALOG_COURSES_LOADED"
      ],
      "catalog courses missing": [
        "CATALOG_COURSES_API_404"
      ]
    },
    "error": [
      "CATALOG_COURSES_API_ERROR"
    ]
  },
  "/tracks": {
    "name": "catalog-old",
    "success": {
      "catalog courses loaded": [
        "CATALOG_COURSES_LOADED"
      ],
      "catalog courses missing": [
        "CATALOG_COURSES_API_404"
      ]
    },
    "error": [
      "CATALOG_COURSES_API_ERROR"
    ]
  },
  "/results/page/:page": {
    "name": "catalog-paginated",
    "success": {
      "catalog courses loaded": [
        "CATALOG_COURSES_LOADED"
      ],
      "catalog courses missing": [
        "CATALOG_COURSES_API_404"
      ]
    },
    "error": [
      "CATALOG_COURSES_API_ERROR"
    ]
  },
  "/results/award/:trackId": {
    "name": "track-award-modal",
    "success": {
      "default": [
        "COURSE_AWARD_VIEW_LOADED"
      ]
    }
  },
  "/tracks/:trackId/exam/award/:trackId": {
    "name": "course-award-view",
    "success": {
      "default": [
        "COURSE_AWARD_VIEW_LOADED"
      ]
    }
  },
  "/tracks/award/:trackId": {
    "name": "award-view",
    "success": {
      "default": [
        "COURSE_AWARD_VIEW_LOADED"
      ]
    }
  },
  "/award/:trackId": {
    "name": "standalone-award-view",
    "success": {
      "default": [
        "COURSE_AWARD_VIEW_LOADED"
      ]
    }
  },
  "/tracks/:trackId/:lessonId/:contentId": {
    "name": "track-content",
    "success": {
      "course loaded": [
        "COURSE_VIEW_LOADED"
      ],
      "course missing": [
        "COURSE_VIEW_API_404"
      ],
      "lesson missing": [
        "COURSE_VIEW_CONTENT_MISSING_ERROR"
      ]
    },
    "error": [
      "COURSE_VIEW_API_ERROR"
    ]
  },
  "/tracks/:trackId/:lessonId/:contentId/award/:trackId": {
    "name": "award-view-content",
    "success": {
      "default": [
        "COURSE_AWARD_VIEW_LOADED"
      ]
    }
  },
  "/tracks/:trackId/intro": {
    "name": "track-intro",
    "success": {
      "intro loaded": [
        "COURSE_INTRO_VIEW_LOADED"
      ],
      "intro missing": [
        "COURSE_INTRO_VIEW_API_404"
      ]
    },
    "error": [
      "COURSE_INTRO_VIEW_API_ERROR"
    ]
  },
  "/tracks/:trackId/exam": {
    "name": "track-exam",
    "success": {
      "exam loaded": [
        "COURSE_EXAM_VIEW_LOADED"
      ],
      "exam missing": [
        "COURSE_EXAM_VIEW_API_404"
      ]
    },
    "error": [
      "COURSE_EXAM_VIEW_API_ERROR"
    ]
  },
  "/tracks/:trackId/complete": {
    "name": "track-conclusion",
    "success": {
      "course complete": [
        "COURSE_CONCLUSION_VIEW_LOADED",
        "COURSE_CONCLUSION_COMPLETE_VIEW_LOADED"
      ],
      "course incomplete": [
        "COURSE_CONCLUSION_VIEW_LOADED",
        "COURSE_CONCLUSION_INCOMPLETE_VIEW_LOADED"
      ]
    }
  },
  "/tracks/:trackId/recommendations": {
    "name": "track-recommendations",
    "success": {
      "default": [
        "TRACK_RECOMMENDATIONS_LOADED"
      ]
    }
  },
  "/tracks/:trackId/next-in-playlist": {
    "name": "track-next-in-playlist",
    "success": {
      "default": [
        "TRACK_NEXT_IN_PLAYLIST_LOADED"
      ]
    }
  },
  "/tracks/:trackId/playlist-incomplete": {
    "name": "track-playlist-incomplete",
    "success": {
      "default": [
        "TRACK_PLAYLIST_INCOMPLETE_LOADED"
      ]
    }
  },
  "/tracks/:trackId/playlist-complete": {
    "name": "track-playlist-complete",
    "success": {
      "default": [
        "TRACK_PLAYLIST_COMPLETE_LOADED"
      ]
    }
  },
  "/tracks/:trackId": {
    "name": "track",
    "success": {
      "course missing": [
        "COURSE_VIEW_API_404"
      ],
      "lesson missing": [
        "COURSE_VIEW_CONTENT_MISSING_ERROR"
      ]
    },
    "error": [
      "COURSE_VIEW_API_ERROR"
    ]
  },
  "/tracks/:trackId/:lessonId": {
    "name": "track-lesson",
    "success": {
      "course missing": [
        "COURSE_VIEW_API_404"
      ],
      "lesson missing": [
        "COURSE_VIEW_CONTENT_MISSING_ERROR"
      ]
    },
    "error": [
      "COURSE_VIEW_API_ERROR"
    ]
  },
  "/tracks/:trackId/recommendations/award/:trackId": {
    "name": "track-recommendations-award-view",
    "success": {
      "default": [
        "COURSE_AWARD_VIEW_LOADED"
      ]
    }
  },
  "/partners": {
    "name": "partners",
    "success": {
      "partners loaded": [
        "CATALOG_COURSES_LOADED"
      ],
      "partners missing": [
        "CATALOG_COURSES_API_404"
      ]
    },
    "error": [
      "CATALOG_COURSES_API_ERROR"
    ]
  },
  "/mylearning/*": {},
  "/mylearning": {},
  "/my-learning/award/:trackId": {
    "name": "track-award-view",
    "success": {
      "default": [
        "COURSE_AWARD_VIEW_LOADED"
      ]
    }
  },
  "/my-learning": {
    "name": "my-learning",
    "success": {
      "courses loaded": [
        "MYLEARNING_LISTING_LOADED"
      ],
      "courses missing": [
        "MYLEARNING_LISTING_API_404"
      ],
      "no results": [
        "MYLEARNING_LISTING_NO_RESULTS"
      ]
    },
    "error": [
      "MYLEARNING_LISTING_API_ERROR"
    ]
  },
  "/saved-items/playlists/:playlistId/assignments/:portalId": {
    "name": "playlist-assignments",
    "success": {
      "playlist assignments loaded": [
        "PLAYLIST_ASSIGNMENTS_LOADED"
      ],
      "playlist assignments empty": [
        "PLAYLIST_ASSIGNMENTS_EMPTY"
      ]
    }
  },
  "/saved-items/playlists": {
    "name": "my-playlists",
    "success": {
      "my playlists loaded": [
        "MY_PLAYLISTS_LISTING_LOADED"
      ],
      "my playlists missing": [
        "MY_PLAYLISTS_LISTING_API_404"
      ]
    },
    "error": [
      "MY_PLAYLISTS_LISTING_API_ERROR"
    ]
  },
  "/saved-items/playlists/all": {
    "name": "my-playlists-all",
    "success": {
      "my playlists loaded": [
        "MY_PLAYLISTS_LISTING_LOADED"
      ],
      "my playlists missing": [
        "MY_PLAYLISTS_LISTING_API_404"
      ]
    },
    "error": [
      "MY_PLAYLISTS_LISTING_API_ERROR"
    ]
  },
  "/saved-items/playlists/saved": {
    "name": "my-playlists-saved",
    "success": {
      "my playlists loaded": [
        "MY_PLAYLISTS_LISTING_LOADED"
      ],
      "my playlists missing": [
        "MY_PLAYLISTS_LISTING_API_404"
      ]
    },
    "error": [
      "MY_PLAYLISTS_LISTING_API_ERROR"
    ]
  },
  "/saved-items/playlists/assigned-to-me": {
    "name": "my-playlists-assigned-to-me",
    "success": {
      "my playlists loaded": [
        "MY_PLAYLISTS_LISTING_LOADED"
      ],
      "my playlists missing": [
        "MY_PLAYLISTS_LISTING_API_404"
      ]
    },
    "error": [
      "MY_PLAYLISTS_LISTING_API_ERROR"
    ]
  },
  "/saved-items/playlists/created-by-me": {
    "name": "my-playlists-created-by-me",
    "success": {
      "my playlists loaded": [
        "MY_PLAYLISTS_LISTING_LOADED"
      ],
      "my playlists missing": [
        "MY_PLAYLISTS_LISTING_API_404"
      ]
    },
    "error": [
      "MY_PLAYLISTS_LISTING_API_ERROR"
    ]
  },
  "/saved-items/playlists/archived": {
    "name": "my-playlists-archived",
    "success": {
      "my playlists loaded": [
        "MY_PLAYLISTS_LISTING_LOADED"
      ],
      "my playlists missing": [
        "MY_PLAYLISTS_LISTING_API_404"
      ]
    },
    "error": [
      "MY_PLAYLISTS_LISTING_API_ERROR"
    ]
  },
  "/saved-items/playlists/:playlistId": {
    "name": "playlist-details",
    "success": {
      "playlist details loaded": [
        "PLAYLIST_DETAILS_LOADED"
      ]
    },
    "error": [
      "PLAYLIST_DETAILS_API_ERROR"
    ]
  },
  "/saved-items/playlists/page/:page": {
    "name": "my-playlists-paged",
    "success": {
      "my playlists loaded": [
        "MY_PLAYLISTS_LISTING_LOADED"
      ],
      "my playlists missing": [
        "MY_PLAYLISTS_LISTING_API_404"
      ]
    },
    "error": [
      "MY_PLAYLISTS_LISTING_API_ERROR"
    ]
  },
  "/saved-items/playlists/:tab/page/:page": {
    "name": "my-playlists-archived-paged",
    "success": {
      "my playlists loaded": [
        "MY_PLAYLISTS_LISTING_LOADED"
      ],
      "my playlists missing": [
        "MY_PLAYLISTS_LISTING_API_404"
      ]
    },
    "error": [
      "MY_PLAYLISTS_LISTING_API_ERROR"
    ]
  },
  "/hubspot-playlists-admin": {
    "name": "hubspot-playlists-admin",
    "success": {
      "hubspot playlists admin loaded": [
        "HUBSPOT_PLAYLISTS_ADMIN_LOADED"
      ],
      "hubspot playlists admin missing": [
        "HUBSPOT_PLAYLISTS_ADMIN_API_404"
      ]
    },
    "error": [
      "HUBSPOT_PLAYLISTS_ADMIN_API_ERROR"
    ]
  },
  "/team": {},
  "/my-team": {
    "name": "my-team",
    "success": {
      "all loaded": [
        "TOP_CERTIFICATIONS_LOADED",
        "CERTIFICATION_TOTALS_BY_TOPIC_LOADED",
        "RECENT_CERTIFICATIONS_LOADED",
        "UPCOMING_CERTIFICATION_EXPIRATIONS_LOADED",
        "RECENT_COMPLETED_PLAYLISTS_LOADED",
        "INCOMPLETE_PLAYLISTS_LOADED"
      ],
      "no access": [
        "NO_ACCESS_404"
      ],
      "no active certifications": [
        "NO_ACTIVE_CERTIFICATIONS_EMPTY_STATE"
      ]
    },
    "error": [
      "TOP_CERTIFICATIONS_API_ERROR",
      "CERTIFICATION_TOTALS_BY_TOPIC_API_ERROR",
      "RECENT_CERTIFICATIONS_API_ERROR",
      "UPCOMING_CERTIFICATION_EXPIRATIONS_API_ERROR",
      "RECENT_COMPLETED_PLAYLISTS_API_ERROR",
      "INCOMPLETE_PLAYLISTS_API_ERROR"
    ]
  },
  "/my-team/certifications": {
    "name": "my-team-certifications",
    "success": {
      "certifications loaded": [
        "CERTIFICATIONS_LOADED"
      ],
      "certifications empty": [
        "CERTIFICATIONS_EMPTY"
      ]
    },
    "error": [
      "CERTIFICATION_API_ERROR"
    ]
  },
  "/my-team/certifications/:certificationId": {},
  "/my-team/certifications/:certificationId/:certificationStatus": {
    "name": "my-team-certification-profile",
    "success": {
      "certification table loaded": [
        "CERTIFICATION_TABLE_LOADED"
      ],
      "no access": [
        "NO_ACCESS_404"
      ],
      "certification table empty": [
        "CERTIFICATION_TABLE_EMPTY"
      ]
    },
    "error": [
      "CERTIFICATION_TABLE_API_ERROR",
      "CERTIFICATION_INFO_API_ERROR"
    ]
  },
  "/my-team/certifications-by-team": {},
  "/my-team/certifications-by-team/:certificationStatus": {
    "name": "my-team-certifications-by-team",
    "success": {
      "certifications by team table loaded": [
        "CERTIFICATIONS_BY_TEAM_TABLE_LOADED"
      ],
      "no access": [
        "NO_ACCESS_404"
      ],
      "certifications by team table empty": [
        "CERTIFICATIONS_BY_TEAM_TABLE_EMPTY"
      ]
    },
    "error": [
      "CERTIFICATIONS_BY_TEAM_TABLE_API_ERROR"
    ]
  },
  "/my-team/playlists": {},
  "/my-team/playlists/:playlistStatus": {
    "name": "my-team-playlists",
    "success": {
      "my team playlists loaded": [
        "MY_TEAM_PLAYLISTS_TABLE_LOADED"
      ],
      "my team playlists empty": [
        "MY_TEAM_PLAYLISTS_TABLE_EMPTY"
      ]
    },
    "error": [
      "MY_TEAM_PLAYLISTS_TABLE_API_ERROR"
    ]
  },
  "/my-team/members": {
    "name": "my-team-members",
    "success": {
      "my team members loaded": [
        "TEAM_MEMBERS_LOADED"
      ],
      "my team members table empty": [
        "TEAM_MEMBERS_EMPTY"
      ]
    },
    "error": [
      "TEAM_MEMBERS_API_ERROR"
    ]
  },
  "/profile/edit": {
    "name": "edit profile page",
    "success": {
      "edit profile page loaded": [
        "EDIT_PROFILE_LOAD"
      ]
    }
  },
  "/profile/:userId": {
    "name": "profile page",
    "success": {
      "profile page loaded": [
        "PROFILE_LOAD"
      ],
      "no profile found": [
        "PROFILE_NOT_FOUND_LOAD"
      ]
    },
    "error": [
      "PROFILE_LOAD_FAILURE"
    ]
  },
  "/profile": {
    "name": "my profile",
    "success": {
      "my profile page loaded": [
        "PROFILE_LOAD"
      ],
      "my profile not found": [
        "PROFILE_NOT_FOUND_LOAD"
      ]
    },
    "error": [
      "PROFILE_LOAD_FAILURE"
    ]
  },
  "/lessons": {
    "name": "lesson-content",
    "success": {
      "lesson loaded": [
        "LESSON_VIEW_LOADED"
      ],
      "lesson missing": [
        "LESSON_VIEW_API_404"
      ],
      "content missing": [
        "LESSON_VIEW_CONTENT_MISSING_ERROR"
      ]
    },
    "error": [
      "LESSON_VIEW_API_ERROR"
    ]
  },
  "/lessons/:lessonId/recommendations/award/:trackId": {
    "name": "lesson-recommendations-award-view",
    "success": {
      "default": [
        "COURSE_AWARD_VIEW_LOADED"
      ]
    }
  },
  "/software-discovery": {
    "name": "software-discovery-no-tool",
    "success": {
      "default": [
        "SOFTWARE_DISCOVERY_LOADED"
      ]
    },
    "error": [
      "SOFTWARE_DISCOVERY_ERROR"
    ]
  },
  "/software-discovery/:appPath": {
    "name": "software-discovery",
    "success": {
      "default": [
        "SOFTWARE_DISCOVERY_LOADED"
      ]
    },
    "error": [
      "SOFTWARE_DISCOVERY_ERROR"
    ]
  },
  "/award-share/:trackId": {
    "name": "award-share-controls",
    "success": {
      "award share controls loaded": [
        "AWARD_SHARE_CONTROLS_LOADED"
      ]
    }
  },
  "/award-share/:trackId/achievement-preview": {
    "name": "award-share-achievement-preview",
    "success": {
      "achievement loaded": [
        "ACHIEVEMENT_LOADED"
      ],
      "achievement missing": [
        "ACHIEVEMENT_MISSING"
      ]
    }
  },
  "/achievements/:publicId/:language/:achievementId/:achieverName/:trackName": {
    "name": "achievements-public",
    "success": {
      "achievement loaded": [
        "ACHIEVEMENT_LOADED"
      ],
      "achievement missing": [
        "ACHIEVEMENT_MISSING"
      ]
    }
  },
  "/shortvideo/:shortId/next-in-playlist": {
    "name": "short-next-in-playlist",
    "success": {
      "default": [
        "SHORT_NEXT_IN_PLAYLIST_LOADED"
      ]
    }
  },
  "/shortvideo/:shortId/playlist-incomplete": {
    "name": "short-playlist-incomplete",
    "success": {
      "default": [
        "SHORT_PLAYLIST_INCOMPLETE_LOADED"
      ]
    }
  },
  "/shortvideo/:shortId/playlist-complete": {
    "name": "short-playlist-complete",
    "success": {
      "default": [
        "SHORT_PLAYLIST_COMPLETE_LOADED"
      ]
    }
  },
  "/shortvideo/:shortId": {
    "name": "short-content",
    "success": {
      "short form loaded": [
        "SHORT_CONTENT_LOADED"
      ],
      "short form recommendations loaded": [
        "RECOMMENDATIONS_FOR_ENTITY_LOADED"
      ],
      "short form missing": [
        "SHORT_CONTENT_API_404"
      ]
    },
    "error": [
      "SHORT_CONTENT_API_ERROR",
      "RECOMMENDATIONS_FOR_ENTITY_API_ERROR"
    ]
  },
  "/practice-mode": {
    "name": "practice-mode",
    "success": {
      "default": [
        "PRACTICE_MODE_LOADED"
      ]
    },
    "error": [
      "SOFTWARE_DISCOVERY_ERROR"
    ]
  },
  "/lessons/*": {
    "name": "lesson-content-wildcard",
    "success": {
      "lesson loaded": [
        "LESSON_VIEW_LOADED"
      ],
      "lesson missing": [
        "LESSON_VIEW_API_404"
      ],
      "lesson forbidden": [
        "LESSON_VIEW_API_403"
      ]
    },
    "error": [
      "LESSON_VIEW_API_ERROR"
    ]
  },
  "/watch-later": {
    "name": "watch-later",
    "success": {
      "watch later items loaded": [
        "WATCH_LATER_LOADED"
      ],
      "watch later items missing": [
        "WATCH_LATER_API_404"
      ],
      "no results": [
        "WATCH_LATER_NO_RESULTS"
      ]
    },
    "error": [
      "WATCH_LATER_API_ERROR"
    ]
  },
  "/course-overview/*": {},
  "/lesson-overview/*": {}
};